import React from 'react'

import { useTranslation } from 'react-i18next'

import { useRegionLoading } from '@/contexts/region-loading'

export const RegionLoadingOverlay: React.FC = () => {
  const { t } = useTranslation('common')
  const { isLoadingRegionSwitch } = useRegionLoading()

  if (!isLoadingRegionSwitch) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-500" />
        <p className="text-sm text-gray-600">{t('alterando_unidade_negocio')}</p>
      </div>
    </div>
  )
}
